module.exports = __webpack_public_path__ + "static/fonts/inter-v18-cyrillic_cyrillic-ext_latin_latin-ext-300.5996850.eot";